function initTilt() {
  if (!window.matchMedia("(min-width: 1024px)").matches) return;

  document
    .querySelectorAll(".image-block--ATWJDMi96QVltTUpCQ__image_hFhd7W")
    .forEach((el) => {
      if (el.vanillaTilt) return;

      VanillaTilt.init(el, {
        max: 10,
        speed: 2500,
        scale: 1.02,
        glare: true,
        "max-glare": 0.25,
        transition: true,
        reset: true,
         "full-page-listening": true,
  "mouse-event-element": document.body

      });
    });
}



document.addEventListener("DOMContentLoaded", initTilt);
document.addEventListener("shopify:section:load", initTilt);


document.addEventListener("DOMContentLoaded", () => {
  const btn = document.querySelector(".button--AbDBFWEpBTzd4cTZ1Z__button_qHzixK");
  if (!btn) return;

  let angle = 0;
  const rotate = () => {
    angle = (angle + 1.5) % 360; 
    btn.style.setProperty("--angle", `${angle}deg`);
    requestAnimationFrame(rotate);
  };
  rotate();
});

document.addEventListener("shopify:section:load", () => {
  const btn = document.querySelector(".button--AbDBFWEpBTzd4cTZ1Z__button_qHzixK");
  if (!btn) return;

  let angle = 0;
  const rotate = () => {
    angle = (angle + 1.5) % 360;
    btn.style.setProperty("--angle", `${angle}deg`);
    requestAnimationFrame(rotate);
  };
  rotate();
});

function vrAddButtonAura() {
  document.querySelectorAll(".button--AbDBFWEpBTzd4cTZ1Z__button_qHzixK").forEach((btn) => {
    if (btn.querySelector(".vr-rot-glow")) return;
    const glow = document.createElement("span");
    glow.className = "vr-rot-glow";
    btn.insertBefore(glow, btn.firstChild);
  });
}

document.addEventListener("DOMContentLoaded", vrAddButtonAura);
document.addEventListener("shopify:section:load", vrAddButtonAura);

document.addEventListener('DOMContentLoaded', function() {
  const buttonSelector = '.button--AbDBFWEpBTzd4cTZ1Z__button_qHzixK';
  const sectionStoreId = 'shopify-section-template--25938420891968__product_list_fa6P9H';
  const sectionLinksId = 'shopify-section-template--25938420891968__streaming_links_YfLhEV';
  
  const btn = document.querySelector(buttonSelector);
  const sectionStore = document.getElementById(sectionStoreId);
  const sectionLinks = document.getElementById(sectionLinksId);

  if (!btn || !sectionStore || !sectionLinks) return;

  btn.removeAttribute('disabled');
  btn.disabled = false;
  
  let isToggled = false;

  function smoothTextChange(newText) {
    const currentWidth = btn.getBoundingClientRect().width;
    btn.style.width = currentWidth + 'px';

    btn.style.color = 'transparent'; 

    setTimeout(() => {
      const ghost = btn.cloneNode(true);
      ghost.style.position = 'absolute';
      ghost.style.visibility = 'hidden';
      ghost.style.width = 'auto'; 
      ghost.textContent = newText;
      document.body.appendChild(ghost);
      
      const targetWidth = ghost.getBoundingClientRect().width;
      
      document.body.removeChild(ghost);

      const glow = btn.querySelector('.vr-rot-glow');
      btn.textContent = newText;
      if (glow) btn.prepend(glow);
      
      void btn.offsetWidth; 
      btn.style.width = targetWidth + 'px';
      btn.style.color = ''; 

      setTimeout(() => {
        btn.style.width = ''; 
      }, 400); 

    }, 200); 
  }

  btn.addEventListener('click', function(e) {
    e.preventDefault(); 
    e.stopPropagation();

    if (!isToggled) {
      smoothTextChange("VIEW STORE");
      
      sectionStore.classList.add('custom-fade-hidden');
      setTimeout(() => {
        sectionStore.style.display = 'none'; 
        sectionLinks.style.display = 'block'; 
        void sectionLinks.offsetWidth; 
        sectionLinks.style.opacity = '1'; 
        sectionLinks.classList.remove('custom-fade-hidden');
      }, 500);
      isToggled = true;

    } else {
      smoothTextChange("STREAM THE EP");

      sectionLinks.classList.add('custom-fade-hidden');
      setTimeout(() => {
        sectionLinks.style.display = 'none'; 
        sectionStore.style.display = 'block'; 
        void sectionStore.offsetWidth;
        sectionStore.style.opacity = '1';
        sectionStore.classList.remove('custom-fade-hidden');
      }, 500);
      isToggled = false;
    }
  });
});